export const DATE_FORMAT = "dd-MM-yyyy";
export const DATE_TIME_FORMAT = "dd-MM-yyyy HH:mm";
